module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9Im1pbS1kZWdyYWRhdGlvbiIgb3ZlcmZsb3c9InZpc2libGUiCgkJcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmlld0JveD0iMCAwIDEwMCAxMDAiPgoJPGRlc2M+bWltLWRlZ3JhZGF0aW9uPC9kZXNjPgoJPGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNDkiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cgk8bGluZSAgeDE9IjEiIHkxPSIxIiB4Mj0iMTAwIiB5Mj0iMTAwIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxIiAvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/mim-degradation.svg
// module id = 702
// module chunks = 0